import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { ScrapCauseModel } from '@/libs/Api';
import { ScrapCausesDataService } from '@/libs/scrap-causes/scrap-causes-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const scrapCausesStore = registerCrudStore<ScrapCauseModel, ScrapCauseModel>(
    BusinessModule.ScrapCause,
    new ScrapCausesDataService()
);